import { render, staticRenderFns } from "./StatusSummary.vue?vue&type=template&id=0d31a7e8&"
import script from "./StatusSummary.vue?vue&type=script&lang=js&"
export * from "./StatusSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports